import { createContext, useCallback, useContext } from 'react';
import { aiFieldCompletion } from '../services/WebsitesService';
import { useDashboardContext } from './DashboardContext';
import { UserContext } from './UserContext';

interface AISuggestionsContextProps {
  fieldSuggestions: (
    websiteId: string,
    sectionId: string,
    fieldName: string,
    fieldContent: string,
    textSelection?: string | null,
    prompt?: string | null,
  ) => Promise<any>;
}

export const AISuggestionsContext = createContext<AISuggestionsContextProps>({
  fieldSuggestions: async () => {},
});

export function AISuggestionsContextProvider(props: any) {
  const { selectedAccount } = useContext(UserContext);
  const { selectedDynamicPage } = useDashboardContext();

  const fieldSuggestions = useCallback(
    async (
      websiteId: string,
      sectionId: string,
      fieldName: string,
      fieldContent: string,
      textSelection?: string | null,
      prompt?: string | null,
    ) => {
      if (!selectedAccount || !selectedDynamicPage) {
        return;
      }
      return aiFieldCompletion(
        selectedAccount.id,
        selectedDynamicPage.id,
        '',
        websiteId,
        sectionId,
        fieldName,
        fieldContent,
        textSelection,
        prompt,
      );
    },
    [selectedAccount, selectedDynamicPage],
  );

  return (
    <AISuggestionsContext.Provider
      value={{
        fieldSuggestions,
      }}
    >
      {props.children}
    </AISuggestionsContext.Provider>
  );
}

export function useAISuggestionsContext() {
  const context = useContext(AISuggestionsContext);
  if (!context) {
    throw new Error(
      'useAISuggestionsContext must be used within an AISuggestionsContextProvider',
    );
  }
  return context;
}
